export const promoteIdIsObject = (prev) => !!prev && typeof prev !== 'string';
//# sourceMappingURL=mapboxLayers.js.map